import { JSX } from 'react'
import { WasteCategory } from '../interfaces'

enum Align {
  Left = 'left',
  Right = 'right',
  Center = 'center'
}

interface TableHeaderType {
  title: string
  field: string
  align: Align
  collapsible?: boolean
  render?: (row: any) => JSX.Element
  width?: string
  disableSorting?: boolean
}

export const getColumns = (): TableHeaderType[] => [
  {
    title: 'Cod',
    field: 'regularizationCode',
    align: Align.Left,
    width: '100px',
    disableSorting: true
  },
  {
    title: 'Articol',
    field: 'articleName',
    align: Align.Left,
    disableSorting: true
  },
  {
    title: 'Data miscare',
    field: 'dateOfRegularization',
    align: Align.Left,
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Motiv',
    field: 'regularizationDescription',
    align: Align.Left,
    width: '120px',
    disableSorting: true
  },
  {
    title: 'PCB',
    field: 'pcb',
    align: Align.Right,
    width: '70px',
    disableSorting: true
  },
  {
    title: 'Cant. UC / Greutate',
    field: 'totalGrossWeightPerLine',
    align: Align.Right,
    width: '100px',
    disableSorting: true
  },
  {
    title: 'Unit. vanzare',
    field: 'salesUnit',
    align: Align.Right,
    width: '100px',
    disableSorting: true
  },
  {
    title: 'Valorizare pret mediu ponderat',
    field: 'pmpPerArticle',
    align: Align.Right,
    disableSorting: true
  },
  {
    title: 'Pret vanzare',
    field: 'salesPricePerLineWithTax',
    align: Align.Right,
    disableSorting: true
  }
]

export const getRows = (wasteCategory: WasteCategory) => {
  return [
    {
      regularizationCode: '',
      articleName: '',
      dateOfRegularization: '',
      regularizationDescription: '',
      pcb: '',
      totalGrossWeightPerLine: '',
      salesUnit: '',

      pmpPerArticle: `Total: ${wasteCategory.totalAveragePrice}`,
      salesPricePerLineWithTax: `Valoare HT: ${wasteCategory.totalPriceHT}`
    },
    {
      regularizationCode: '',
      articleName: '',
      dateOfRegularization: '',
      regularizationDescription: '',
      pcb: '',
      totalGrossWeightPerLine: '',
      salesUnit: '',
      pmpPerArticle: '',

      salesPricePerLineWithTax: `Valoare TTI (TVA 9): ${wasteCategory.totalPriceTTI}`
    }
  ]
}
